<template>
    <p
        class="textarea"
        :class="{'is-collapsed-if-empty': isCollapsedIfEmpty}"
        ref="editable"
        id="content"
        :placeholder="placeholder"
        contenteditable
        v-on="listeners"
        @keyup.ctrl.enter="send"
        @keyup.esc="send"
    />
</template>

<script>
export default {
    name: "Editable",
    props: {
        placeholder: null,
        isCollapsedIfEmpty: false,
        value: {
            type: String,
            default: '',
        },
    },
    computed: {
        listeners() {
            return { ...this.$listeners, input: this.onInput };
        },
    },
    mounted() {
        this.$refs.editable.innerText = this.value;
    },
    methods: {
        onInput(e) {
            this.$emit('input', e.target.innerText);
        },
        send() {
            if (this.$refs.editable.innerText) {
                this.$emit('send');
            }
        },
    },
    watch: {
        value(newValue, oldValue) {
            if (newValue === '') {
                this.$refs.editable.innerText = "";
            }
        }
    },
};
</script>

<style lang="scss" scoped>
    .bulma .textarea {
        overflow: hidden;
        font-size: 14px;
        background: #FFFFFF;
        border: 1px solid #DEDEDE;
        box-sizing: border-box;
        border-radius: 6px;
        min-height: 120px;
        width: calc(100% - 2px);
        height: auto;
        word-break: break-all;
        &[contenteditable][placeholder]:empty:before {
            content: attr(placeholder);
            position: absolute;
            color: #838383;
            font-size: 16px;
            margin-top: 7px;
            margin-left: 10px;
        }
        &.is-collapsed-if-empty[contenteditable][placeholder]:focus:empty:before {
            content: '';
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 24px;
        }
        &:focus:empty {
            min-height: 120px;
            background: #FFFFFF;
        }
        &.is-collapsed-if-empty:not(:focus):empty {
            min-height: 40px;
            padding: 0;
            background: #FAFAFA;
        }
    }
</style>
